module.exports = __webpack_public_path__ + "img/imgWeb1.9ab3167c.png";